module.exports = __webpack_public_path__ + "img/margaret.9bba7acb.jpg";